import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Typography, Color, Error } from '@figure/frontlib-gui';
import { VisuallyHidden } from '@figure/frontlib-accessibility';

const Container = styled.div`
  > * {
    margin-bottom: 24px;
  }
`;

const Input = styled.input`
  opacity: 0;
  position: absolute;
`;

const Label = styled.label`
  display: inline-block;
  font-family: 'Poppins';
  height: 4rem;
  width: 4rem;
  font-size: 1.8em;
  font-weight: 700;
  padding-top: 0.6rem;
  text-align: center;
  border: 1px solid ${Color.GREY_3};
  border-radius: 50%;
  margin-right: 8px;
  margin-bottom: 8px;

  :hover {
    background-color: ${Color.PURPLE_RAIN};
    color: ${Color.WHITE};
  }
`;

const NPSScale = styled.div`
  input[type='radio']:checked + label {
    background-color: ${Color.PURPLE_RAIN};
    color: ${Color.WHITE};
  }

  input[type='radio']:focus + label {
    border: 1px solid ${Color.FOCUS};
    outline: 1px solid transparent;
  }
`;

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 8px;
`;

const Fieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
`;

const NPSCollection = ({ errors, touched, setFieldValue }) => {
  const handleClick = (event) => setFieldValue('npsScore', event.target.value);

  return (
    <Container>
      <Typography.Body>
        Leave us your feedback and <strong>receive a free gift</strong>. On a scale from 0-10, how likely are you to recommend Figure
        to a friend, family member or colleague?
      </Typography.Body>

      <NPSScale>
        <Fieldset>
          {touched.npsScore && errors.npsScore && <Error display="block">{errors.npsScore}</Error>}
          <VisuallyHidden as="legend">Rating. 0 is not at all likely. 10 is extremely likely</VisuallyHidden>
          <Input type="radio" name="satisfaction-score" id="score-0" value="0" onClick={handleClick} />
          <Label htmlFor="score-0">0</Label>
          <Input type="radio" name="satisfaction-score" id="score-1" value="1" onClick={handleClick} />
          <Label htmlFor="score-1">1</Label>
          <Input type="radio" name="satisfaction-score" id="score-2" value="2" onClick={handleClick} />
          <Label htmlFor="score-2">2</Label>
          <Input type="radio" name="satisfaction-score" id="score-3" value="3" onClick={handleClick} />
          <Label htmlFor="score-3">3</Label>
          <Input type="radio" name="satisfaction-score" id="score-4" value="4" onClick={handleClick} />
          <Label htmlFor="score-4">4</Label>
          <Input type="radio" name="satisfaction-score" id="score-5" value="5" onClick={handleClick} />
          <Label htmlFor="score-5">5</Label>
          <Input type="radio" name="satisfaction-score" id="score-6" value="6" onClick={handleClick} />
          <Label htmlFor="score-6">6</Label>
          <Input type="radio" name="satisfaction-score" id="score-7" value="7" onClick={handleClick} />
          <Label htmlFor="score-7">7</Label>
          <Input type="radio" name="satisfaction-score" id="score-8" value="8" onClick={handleClick} />
          <Label htmlFor="score-8">8</Label>
          <Input type="radio" name="satisfaction-score" id="score-9" value="9" onClick={handleClick} />
          <Label htmlFor="score-9">9</Label>
          <Input type="radio" name="satisfaction-score" id="score-10" value="10" onClick={handleClick} />
          <Label htmlFor="score-10">10</Label>
          <DescriptionContainer>
            <Typography.SmallBodyGrey aria-hidden="true">0 - Not at all likely</Typography.SmallBodyGrey>
            <Typography.SmallBodyGrey aria-hidden="true">10 - Extremely likely</Typography.SmallBodyGrey>
          </DescriptionContainer>
        </Fieldset>
      </NPSScale>
    </Container>
  );
};

NPSCollection.propTypes = {
  errors: PropTypes.shape({ npsScore: PropTypes.string }).isRequired,
  touched: PropTypes.shape({ npsScore: PropTypes.bool }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default NPSCollection;
